import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ultraAnimations } from 'app/shared/animations';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	animations: ultraAnimations,
	imports: [IonicModule],
})
export class AppComponent {}
